import ErrorIcon from '@atlaskit/icon/glyph/error';
import React from 'react';
const RUSSIA_ISO_CODE = 'RU';
const BELARUS_ISO_CODE = 'BY';
const BLACKLISTED_COUNTRIES = [RUSSIA_ISO_CODE, BELARUS_ISO_CODE];
const MESSAGE_TITLE = "We stand with Ukraine";
const MESSAGE_DESCRIPTION = 'We have a commitment to our customers to provide a trusted service. In response, we are pausing the sale of all new software to Russia.';
const MESSAGE_LINK = 'https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine';
export const flagConfigForRussianUsers = {
  appearance: 'normal',
  description: MESSAGE_DESCRIPTION,
  title: MESSAGE_TITLE,
  icon: /*#__PURE__*/React.createElement(ErrorIcon, {
    primaryColor: "red"
  }),
  isAutoDismiss: true,
  actions: [{
    content: 'Learn more',
    href: MESSAGE_LINK,
    target: '_blank'
  }]
};
export const isCountryBlacklisted = countryCode => BLACKLISTED_COUNTRIES.some(blacklistedCountry => blacklistedCountry === countryCode);